export default {
  id: null,
  regulationAutoID: null,
  typeConclusion: null,
  reasonFrustration: null,
  reprogramSurvey: null,
  lossType: null,
  budget: null,
  engineNumber: null,
  description: null,
  actionDate: null
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/regulation/sinisterregulation-model.js